import React, { useEffect, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import "./productskumodal.css";
import { updateWarehouseProductsDetails } from "../../../../services/product.service";
import CircularLoader from "../../../../Components/CircularLoader/CircularLoader";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export default function ProductSKUModal({
  open,
  setOpen,
  setProducts,
  setSnack,
}) {
  const { t } = useTranslation(["inventory", "common"]);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [changed, setchanged] = useState(false);

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const response = await updateWarehouseProductsDetails(
        {
          warehouse_sku: data?.warehouse_sku,
        },
        data?.id
      );
      if (!response.error) {
        setProducts((prevProducts) => {
          return {
            ...prevProducts,
            data: prevProducts?.data?.map((product) => {
              if (product.id == open?.row?.product_warehouse[0]?.product_id) {
                return {
                  ...product,
                  product_warehouse: [
                    {
                      ...product?.product_warehouse[0],
                      warehouse_sku: data?.warehouse_sku,
                    },
                  ],
                };
              }
              return product;
            }),
          };
        });
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: response?.data?.message,
            severity: "success",
          };
        });
        setLoading(false);
        handleClose();
      } else {
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: response?.data?.message ?? t("common:messages.somethingWentWrong"),
            severity: "error",
          };
        });
        setLoading(false);
      }
    } catch (error) {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: error?.response?.data?.message || t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  const handleClose = () => {
    setOpen(false);
    setData({});
  };

  useEffect(() => {
    if (open) {
      setData({
        code: open?.row?.code,
        full_name: open?.row?.full_name,
        id: open?.row?.product_warehouse[0]?.id,
        productId: open?.row?.id,
        warehouse_sku: open?.row?.product_warehouse[0]?.warehouse_sku ?? "",
      });
    }
  }, [open]);

  useEffect(() => {
    let hasChanges = false;
    if (
      data?.warehouse_sku !=
      (open?.row?.product_warehouse[0]?.warehouse_sku ?? "")
    ) {
      hasChanges = true;
    }
    setchanged(hasChanges);
  }, [data, open]);

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className="prod__sku_modal">
          <div className="prod__sku_modalheading">{t("productModals.productWarehouseSku")}</div>
          <div className="prod__sku__sub_heading">
            {data?.full_name ?? ""}({data?.code ?? ""})
          </div>
          <div className="product_sku_box_line" />

          <div className={"product_sku_box_wrapper"}>
            <div className={"product_sku_box_active"}>
              <div>
                <Form.Label className="prod__sku_box_label">
                  {t("productModals.productWarehouseSku")}
                </Form.Label>
                <Form.Control
                  type="text"
                  className="product_sku_box__input"
                  placeholder={t("productModals.productWarehouseSku")}
                  name="warehouse_sku"
                  value={data?.warehouse_sku}
                  onChange={(e) => handleFieldChange(e)}
                />
              </div>
            </div>
          </div>
          <div className="prod__sku_desc_modalfooter">
            <div className="prod__sku_modalcncl" onClick={handleClose}>
              {t("common:actions.close")}
            </div>
            {changed && (
              <Button
                disabled={loading}
                className="product_sku_box_modalsave"
                onClick={handleSave}
              >
                {loading ? <CircularLoader /> : t("common:actions.save")}
              </Button>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
}
